export const iconFontAwesomeSpinnersCrosshairs = (
	<i className="fa-solid fa-crosshairs"></i>
);
